import { getDirname } from '@poppinss/utils'

export const stubsRoot = getDirname(import.meta.url)
